import { graphql } from 'gatsby';
import get from 'lodash.get';
import React from 'react';

import BlogPostListing from '../components/Blog/BlogPostListing';
import BlogSeo from '../components/Blog/BlogSeo';
import ListingHero from '../components/Blog/ListingHero';
import ContentContainer from '../components/Common/ContentContainer';
import FormBanner from '../components/Common/FormBanner';
import PageSection from '../components/Common/PageSection';
import Layout from '../components/Layouts/Layout';

const latestBlogPosts = ({ data, location }) => {
  let page = {};
  if (data.page) page = data.page;
  const { latestPosts, blogSettings } = data;
  return (
    <Layout isBlog pageMeta={page.pageMetaData}>
      <BlogSeo slug={location.pathname} />
      <PageSection isTopSection>
        <ListingHero heading={'Latest Posts'} />
      </PageSection>
      <ContentContainer>
        <BlogPostListing blogPosts={latestPosts.nodes} />
      </ContentContainer>
      <FormBanner
        id={'subscribe-form'}
        heading={blogSettings.newsletterSignupHeading}
        form={blogSettings.form}
        successMessage={get(blogSettings, 'form.successMessage')}
        formId={blogSettings.marketoFormId}
      />
    </Layout>
  );
};

export default latestBlogPosts;

export const query = graphql`
  query getLatestPosts {
    blogSettings: contentfulBlogSettings(contentful_id: { eq: "6KdgnoVe8iL9MGRTTPgqyQ" }) {
      ...SiteSettings
    }
    latestPosts: allContentfulBlogPost(sort: { order: DESC, fields: publishDate }) {
      nodes {
        id
        title
        slug
        articleDescription {
          articleDescription
        }
        categories {
          categoryName
          slug
        }
        publishDate
        author {
          name
        }
        readTime
        heroImage {
          gatsbyImageData(formats: [AUTO, WEBP], layout: FULL_WIDTH, placeholder: BLURRED)
          file {
            url
            contentType
          }
        }
      }
    }
  }
`;
